import axios from "../../axios";

const getFees = async function (accessToken,userId = {}) {
    try {
        const response = await axios.get('user/fee/getFees' ,{
            headers: {
                'Authorization': accessToken
            },
            params: {
                user_id: userId
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getFees;
